<div class="gains-input">
  <gains-input-title *ngIf="label" [for]="inputId" [label]="label" [required]="required"></gains-input-title>

  <nz-input-group *ngIf="showAddOnBefore" [nzAddOnBefore]="addOnBeforeTemplate" [nzPrefix]="prefixIcon" [nzSuffix]="suffixIcon" [ngClass]="{ 'error-input': displayError }">
    <input
      #field
      [type]="type"
      (keypress)="restrictDecimal($event)"
      (ngModelChange)="onValueChange($event, field)"
      nz-input
      (keyup)="checkError()"
      (blur)="onBlur(field)"
      [id]="inputId"
      [attr.aria-label]="ariaLabel ?? null"
      [attr.autocomplete]="autocomplete ?? null"
      [attr.spellcheck]="spellcheck ?? null"
      [attr.step]="step ?? null"
      [placeholder]="placeholder"
      [formControl]="this.internalFormControl"
      [attr.maxlength]="maxlength ?? null"
    />
  </nz-input-group>

  <ng-template #addOnBeforeTemplate>
    <nz-select [ngModel]="prefixSelectedValue" (ngModelChange)="onPrefixSelectChange($event)" class="prefix-select">
      <nz-option *ngFor="let option of selectOptions" [nzLabel]="option.label" [nzValue]="option.value"></nz-option>
    </nz-select>
  </ng-template>

  <textarea
    *ngIf="!showAddOnBefore && type === 'textarea'"
    nz-input
    [rows]="rows"
    [id]="inputId"
    [attr.aria-label]="ariaLabel ?? null"
    [attr.autocomplete]="autocomplete ?? null"
    [attr.spellcheck]="spellcheck ?? null"
    [placeholder]="placeholder"
    [formControl]="this.internalFormControl"
    [attr.maxlength]="maxlength ?? null"
    [ngClass]="{ 'error-input': displayError }"
    (ngModelChange)="onValueChange($event)"
    (keyup)="checkError()"
    (blur)="onBlur()"
  ></textarea>

  <nz-input-group *ngIf="!showAddOnBefore && type !== 'textarea'" [nzPrefix]="prefixIcon" [nzSuffix]="suffixIcon" [ngClass]="{ 'error-input': displayError }">
    <input
      #field
      [type]="type"
      (keypress)="restrictInput($event)"
      (ngModelChange)="onValueChange($event, field)"
      nz-input
      (keyup)="checkError()"
      (blur)="onBlur(field)"
      [id]="inputId"
      [attr.aria-label]="ariaLabel ?? null"
      [attr.autocomplete]="autocomplete ?? null"
      [attr.spellcheck]="spellcheck ?? null"
      [attr.step]="step ?? null"
      [placeholder]="placeholder"
      [formControl]="this.internalFormControl"
      [attr.maxlength]="maxlength ?? null"
    />
  </nz-input-group>

  <div class="error-message" *ngFor="let message of errorMessagesToDisplay">
    <svg-icon src="assets/icons/exclamation-circle.svg"></svg-icon>
    <span>{{ message }}</span>
  </div>
</div>

<ng-template #prefixIcon>
  <svg-icon *ngIf="icon" [src]="icon"></svg-icon>
</ng-template>

<ng-template #suffixIcon>
  <svg-icon *ngIf="suffixIconLink" [src]="suffixIconLink"></svg-icon>
  <span *ngIf="suffixText" class="suffix-text">{{ suffixText }}</span>
</ng-template>
